<template>
  <div class="section__inner section__inner--noRightpad">
    <div class="section-head">
      <h2 class="section-head__title" :class="[currentLanguage === 'AR' ? 'rtlText' : '']">
        {{ $t('product.relateditems.title') }}
      </h2>
    </div>

    <div class="section-body">
      <Swiper class="swiper carousel-wrapper carousel-wrapper--smpad" v-bind="swiperProps">
        <SwiperSlide
          v-for="ritem in products"
          :key="ritem.product_id"
          :class="isBookType ? 'carousel-item card--v4 card--ebook' : 'carousel-item card--v4'"
        >
          <div class="item-img">
            <router-link
              :to="{
                name: 'ProductDetails',
                params: { productId: ritem.product_id, type: helpers.portal_name }
              }"
            >
              <img :src="ritem.icon_small" alt="Product Name" />
            </router-link>
          </div>

          <div class="item-data">
            <div class="data-value">
              <router-link
                :to="{
                  name: 'ProductDetails',
                  params: { productId: ritem.product_id, type: helpers.portal_name }
                }"
              >
                <h3>{{ ritem.title }}</h3>
              </router-link>
            </div>

            <router-link
              :to="{
                name: 'ProductDetails',
                params: { productId: ritem.product_id, type: helpers.portal_name }
              }"
            >
              <div class="btn--primary btn--sm" :class="[currentLanguage === 'AR' ? 'rtlText' : '']">
                <span v-if="ritem.type === 1">{{ $t('button.playGame') }}</span>
                <span v-else-if="ritem.type === 5">{{ $t('button.playVideo') }}</span>
                <span v-else>{{ $t('button.download') }}</span>
              </div>
            </router-link>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { helpers } from '../helper/portal_config'

export default {
  name: 'RelatedItem',
  props: ['products'],
  components: { Swiper, SwiperSlide },
  data() {
    return {
      helpers: '',
      currentLanguage: '',
      swiperProps: {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 15,
        slidesPerGroup: 1,
        slidesOffsetAfter: 100,
        breakpoints: {
          667: { slidesPerView: 2.2, spaceBetween: 15 },
          767: { slidesPerView: 2.8, spaceBetween: 20 },
          1200: { slidesPerView: 3.8 },
          1600: { slidesPerView: 4.2 }
        }
      }
    }
  },
  computed: {
    isBookType() {
      return this.helpers.portal_name === 'Carefizz'
    }
  },
  created() {
    this.helpers = helpers
    const { host } = window.location
    const country = host.split('.')[0].slice(0, 2).toUpperCase()
    const map = helpers.countryDefaultLanguage || {}
    this.currentLanguage = (map.hasOwnProperty(country) ? map[country] : country).toUpperCase()
  }
}
</script>

<style scoped>
.card--v4.card--ebook .item-img img { object-fit: contain; }
.card--v4.card--ebook .item-img { width: 50px; height: 90px; }
@media (min-width: 1200px) { .card--v4.card--ebook .item-img { width: 90px; height: 120px; } }
@media (min-width: 1600px) { .card--v4.card--ebook .item-img { width: 80px; height: 135px; } }
</style>
